import { SxProps } from '@mui/material';
import { InputAdornment } from '@mui/material';
import { CheckCircleIcon } from '@phosphor-icons/react/dist/ssr/CheckCircle';
import React from 'react';

type TickAdornmentProps = {
  sx?: SxProps, icon?: React.ReactNode
}

export const TickAdornment = ({sx, icon = <CheckCircleIcon size={24} color="#0DBC83" weight="fill" />}: TickAdornmentProps) => (
  <InputAdornment sx={sx}
                  disablePointerEvents
                  position="end">
    {icon}
  </InputAdornment>
);
